<template>
    <div class="displayButtonWrapper" @click="handleShow">
        <!-- Spinner ring with gap -->
        <span class="spinner-ring"></span>

        <!-- Floating button -->
        <div class="displayButton">
            <van-icon :name="isDisplay ? 'cross' : 'plus'" />
        </div>
    </div>

    <transition-group name="pop" tag="div" class="container">
        <div v-for="(item, index) in isDisplay ? homeIconList : []" :key="item?.name" class="icon-wrapper"
            :style="{ transitionDelay: `${index * 0.05}s` }" @click="goToPath(item?.name)">
            <img :src="item?.icon" alt="" />
        </div>
    </transition-group>


</template>

<script setup lang="ts">
import { useActivityStore } from '@/stores/activity';
import { goToActivityPath } from '@/view/home/supportScript';
import { computed, defineEmits, ref } from 'vue';
import { useRouter } from 'vue-router';

const activityStore = useActivityStore()
const homeIconList = computed(() => activityStore.homeFloatActivityList)
const isDisplay = ref(true)
const router = useRouter()
const emits = defineEmits(["openAgentPopup", "openRedEnvelop", "goToHome", "openPWA"])

const goToPath = (name: any) => {
    goToActivityPath(name, router, emits)
}

const handleShow = () => {
    isDisplay.value = !isDisplay.value
}
</script>
<style scoped>

.container {
    position: fixed;
    bottom: 120px;
    right: 10px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-end;
    max-height: 70vh;
    gap: 8px;
    direction: rtl;
}

.container>div {
    display: flex;
    direction: ltr;
}

.container img {
    border-radius: 10px;
    width: 80px;
}

.displayButtonWrapper {
    position: fixed;
    bottom: 95px;
    right: 45px;
    z-index: 1000;
}

/* Spinner ring with gap */
.spinner-ring {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 40px;
    height: 40px;
    border: 1.5px solid #ffb400;
    border-top-color: #ffd05f;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    animation: spin 1s linear infinite;
    z-index: 0;
}

/* Floating button */
.displayButton {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    background: linear-gradient(135deg, #f1641d, #ffad00);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
    z-index: 1;
    transition: all 0.3s ease;
}

.displayButton:hover {
    transform: translate(-50%, -50%) scale(1.1);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
}

/* Spin animation */
@keyframes spin {
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}

/* Transition-group animation */
.pop-enter-from {
    transform: scale(0);
    opacity: 0;
}

.pop-enter-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.pop-enter-to {
    transform: scale(1);
    opacity: 1;
}

.pop-leave-from {
    transform: scale(1);
    opacity: 1;
}

.pop-leave-active {
    transition: all 0.2s ease-in;
}

.pop-leave-to {
    transform: scale(0);
    opacity: 0;
}
</style>